import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import LogoMark from '@/assets/images/Logo_TC_mark.svg?react';
import { Icon } from '@/shared/IconCollecion';
import { Logo } from '@/shared/ui/Logo';

// Страница 404 telecom (макет, раздел 7): красная волна на весь экран, логотип
// сверху, крупный код, в котором нули заменены кольцом со знаком TC, строка
// «Страница не найдена», пояснение и белая кнопка на дашборд. Домена внизу из
// макета нет (решение 24.09).
//
// Фон — токены экрана входа: это та же гостевая подложка.

export function NotFoundView({ code = 404, message }: { code?: number; message?: string }) {
  const { t } = useTranslation('common');
  const text = message ?? t('notFound');

  return (
    <div
      className="flex min-h-screen flex-col items-center bg-surface-auth-page bg-cover bg-center px-4 py-7 md:px-16 md:py-14"
      style={{ backgroundImage: 'var(--auth-bg-image)' }}
    >
      <Logo min={false} size="hero" />

      <div className="flex w-full flex-1 flex-col items-center justify-center">
        <div
          aria-hidden="true"
          className="flex select-none items-center justify-center gap-1 text-[150px] font-extrabold leading-none tracking-[-.04em] text-white/15 md:gap-2 md:text-[260px] lg:gap-3 lg:text-[380px]"
        >
          {String(code)
            .split('')
            .map((digit, i) => (
              <Fragment key={i}>
                {digit === '0' ? (
                  <span className="flex h-[143px] w-32 items-center justify-center rounded-full bg-[rgb(var(--color-crimson-800-rgb)/0.55)] shadow-[inset_0_0_0_10px_rgb(255_255_255/0.14)] md:h-[246px] md:w-[220px] md:shadow-[inset_0_0_0_16px_rgb(255_255_255/0.14)] lg:h-[358px] lg:w-80 lg:shadow-[inset_0_0_0_22px_rgb(255_255_255/0.14)]">
                    <LogoMark className="h-12 w-auto text-white md:h-20 lg:h-[120px]" />
                  </span>
                ) : (
                  <span>{digit}</span>
                )}
              </Fragment>
            ))}
        </div>

        <h1 className="mt-7 text-center text-xl font-extrabold text-white lg:mt-10 lg:text-[26px]">
          {t('notFoundTitle')}
        </h1>
        <p className="mt-2.5 max-w-[420px] text-pretty text-center text-sm leading-[1.55] text-white/90 lg:text-[15px]">
          {text}
        </p>

        <a
          href={import.meta.env.BASE_URL}
          className="mt-7 inline-flex items-center gap-2.5 rounded-full bg-white px-[26px] py-3.5 text-sm font-bold text-content-accent shadow-[0_4px_10px_rgb(40_0_0/0.25)] transition-colors hover:text-content-accent-hover"
        >
          <Icon name="Arrow_Left" color="currentColor" className="size-4 shrink-0" />
          {t('backToDashboard')}
        </a>
      </div>
    </div>
  );
}
